/**
 * @file 开始使用页入口
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, { useCallback } from 'react';
import { Tabs } from 'antd';

import Header from '../../components/header/HeaderWithStore';
import Banner from '../../components/banner/Banner';
import Footer from '../../components/footer/footer';
import QuickPane from './pages/quick/Quick';
import FastDeployPane from './pages/FastDeploy';
import OldDocPane from './pages/old/OldDoc';

import QuickOnhand from './components/quick-onhand/QuickOnhand';
import Guide from './components/guides/Guides';
import Hardware from './components/hardware/Hardware';
import ReactStickyPolyfill from '../../components/react-sticky-polyfill/ReactStickyPolyfill';

import { useHistory, useRouteMatch } from 'react-router-dom';

const Install: React.FC = () => {
    const match = useRouteMatch();
    const history = useHistory();
    const tabActiveKey = match.path;
    const onTabActiveKeyChange = useCallback(
        (key: string) => {
            history.push(key);
            if ((window as any)._hmt) {
                if (key === '/install/old') {
                    (window as any)._hmt.push(['_trackEvent', '安装', 'tab', '点击旧版本安装']);
                } else if (key === '/install/next') {
                    (window as any)._hmt.push(['_trackEvent', '安装', 'tab', '下一步做什么']);
                }
            }
        },
        [history]
    );

    const tipsArr = [
        '飞桨 2.6 版本升级须知：',
        'Python 版本最低要求为 3.8',
        '不再支持 CUDA10.2'
    ];

    return (
        <div className="page paddle-install-page">
            <Header />
            <Banner title="开始使用" subtitle="用飞桨来实现您的AI想法" />
            {/* <div className="paddle-install-page-tips">
                {tipsArr.map(item => (
                    <div className="paddle-install-page-tips-item" key={item}>
                        {item}
                    </div>
                ))} */}
                {/* <div className="paddle-install-page-tips-item">
                    对支持的GPU 架构进行了调整，详细请参阅
                    <a
                        target="_blank"
                        rel="noreferrer"
                        // style={{ marginLeft: '2px' }}
                        href="https://www.paddlepaddle.org.cn/documentation/docs/zh/install/Tables.html#nvidia-gpu"
                    >
                        飞桨支持的GPU架构型号
                    </a>
                </div>
                <div className="paddle-install-page-tips-item">支持Mac M1上 ARM64架构的原生编译，首次发布安装包</div> */}
            {/* </div> */}
            <ReactStickyPolyfill>
                <div className="paddle-install-page-tabs-wrap">
                    <Tabs className="paddle-install-page-tabs" activeKey={tabActiveKey} onChange={onTabActiveKeyChange}>
                        <Tabs.TabPane tab="飞桨快速安装" key="/install/quick"></Tabs.TabPane>
                        <Tabs.TabPane tab="FastDeploy快速安装" key="/install/FastDeploy"></Tabs.TabPane>
                        <Tabs.TabPane tab="更多硬件支持" key="/install/other"></Tabs.TabPane>
                        <Tabs.TabPane tab="旧版本安装" key="/install/old"></Tabs.TabPane>
                        <Tabs.TabPane tab="下一步做什么" key="/install/next"></Tabs.TabPane>
                    </Tabs>
                </div>
            </ReactStickyPolyfill>

            <div className="paddle-install-page-container">
                <Tabs className="paddle-install-page-tabs-body" activeKey={tabActiveKey} animated={false}>
                    <Tabs.TabPane tab="快速安装" key="/install/quick">
                        <QuickPane />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="FastDeploy快速安装" key="/install/FastDeploy">
                        <FastDeployPane />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="更多硬件支持" key="/install/other">
                        <Hardware />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="旧版本安装" key="/install/old">
                        <OldDocPane />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="下一步做什么" key="/install/next">
                        <div className="paddle-install-page-subcontainer">
                            <div className="paddle-context-h2">典型案例</div>
                            <div className="paddle-context-h3">
                                尝试用 Paddle 解决一些深度学习经典问题
                                <a href="/tutorials/projectdetail/695184">查看更多</a>
                            </div>
                            <QuickOnhand />

                            <div className="paddle-context-h2">新手指南</div>
                            <Guide />
                        </div>
                    </Tabs.TabPane>
                </Tabs>
            </div>
            <Footer />
        </div>
    );
};

export default Install;
